
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { Footer } from './component/footer/Footer';
import Header from './component/header/Header';
import Main from './component/main/Main';
import Contact from './component/contacts/Contact';
import Advertise from './component/advise/Advertise';
import PhotoPage from './component/singlePage/PhotoPage';
import VideoPage from './component/singlePage/VideoPage';
import About from './component/about/About';


export const category = [
    {id:1, title: "/videoPage", pages: <VideoPage />},
    {id:2, title: "/photo", pages: <PhotoPage />},
]
function App() {
 
  return (
    <BrowserRouter>
    <Header />
    <Routes>
      <Route path='/' element={<Main />} />
      <Route path='/about' element={<About />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/advrtise' element={<Advertise />} />
      <Route path='/photo' element={<PhotoPage />} />
      <Route path='/video' element={<VideoPage />} />
      {category.map(category => (
        <Route path='/category/:id' element={<VideoPage />} />
      ))}
    </Routes>
    <Footer />
    </BrowserRouter>
  );
}

export default App;
